import * as React from 'react';
import {CreateBreadcrumb, IState} from "./Data";
import {RouteComponentProps} from "react-router";
import {CreateLayout} from "../../layout/CreateLayout";
import {QuestionnaireTypeModel} from "../../model";
import {CreateForm} from "./form/CreateForm";

export class QuesTypesCreate extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      form: {} as QuestionnaireTypeModel
    }
  }

  render() {
    return (
        <CreateLayout breadcrumb={CreateBreadcrumb} title={'Add new questionnaire type'}>
          <CreateForm {...this.state}/>
        </CreateLayout>
    )
  }
}